import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import PremiumSidebar from "./PremiumSidebar";
import PremiumMembers from "./PremiumMembers";
import CustomAppStore from "./CustomAppStore";
import ConsumerAppActive from "./ConsumerAppActive";
import ConsumerAppSettings from "./ConsumerAppSettings";
import InfoRequests from "./InfoRequests";
import ListingMatch from "./ListingMatch";
import showNotification from '../component/Notification';
import baseURL from '../component/baseURL';

export default function PremiumHome() {
    const location = useLocation();
    const navigate = useNavigate();
    const [activeItem, setActiveItem] = useState("");
    const [isMobilePageOpen, setIsMobilePageOpen] = useState(false);
    const [isMobile, setIsMobile] = useState(false);
    const [premiumMembersCount, setPremiumMembersCount] = useState(0);
    const itemToPath = {
        "Premium Members": "/premium-home/premium-members",
        "Consumer Apps Active": "/premium-home/consumer-apps-active",
        "Consumer App Settings": "/premium-home/consumer-app-settings",
        "Info Requests": "/premium-home/info-requests",
        "Listing Match": "/premium-home/listing-match",
        "Custom App Store": "/premium-home/custom-app-store",
    };
    const pathToItem = {
        "/premium-home/premium-members": "Premium Members",
        "/premium-home/consumer-apps-active": "Consumer Apps Active",
        "/premium-home/consumer-app-settings": "Consumer App Settings",
        "/premium-home/info-requests": "Info Requests",
        "/premium-home/listing-match": "Listing Match",
        "/premium-home/custom-app-store": "Custom App Store",
    };

    useEffect(() => {
        const userid = localStorage.getItem('user_id');
        fetchDetailsAPI(userid);
        const checkMobile = () => {
            setIsMobile(window.innerWidth <= 767);
        };

        checkMobile();
        window.addEventListener('resize', checkMobile);

        return () => window.removeEventListener('resize', checkMobile);
    }, []);

    useEffect(() => {
        const normalizedPath = location.pathname.toLowerCase();
        const initial = location.state?.initialActiveItem;
        const fallbackItem = initial || "Premium Members";

        if (initial) {
            const targetPath = itemToPath[fallbackItem] || "/premium-home/premium-members";
            navigate(targetPath, { replace: true, state: {} });
            return;
        }

        if (normalizedPath === "/premium-home" || normalizedPath === "/premium-home/") {
            if (window.innerWidth > 767) {
                navigate("/premium-home/premium-members", { replace: true });
                return;
            }
            setActiveItem("");
            setIsMobilePageOpen(false);
            return;
        }

        const itemFromPath = pathToItem[normalizedPath];
        if (itemFromPath) {
            setActiveItem(itemFromPath);
            if (window.innerWidth <= 767) {
                setIsMobilePageOpen(true);
            }
            if (initial) {
                navigate(normalizedPath, { replace: true, state: {} });
            }
        }
    }, [location.pathname, location.state, navigate]);

    const handleItemClick = (item) => {
        setActiveItem(item);

        // Notify App component about MyConnection view
        const isViewingPremiumMembers = item === "Premium Members";
        window.dispatchEvent(new CustomEvent('premiumMembersView', {
            detail: { isViewing: isViewingPremiumMembers }
        }));

        const targetPath = itemToPath[item] || "/premium-home/premium-members";
        if (location.pathname.toLowerCase() !== targetPath.toLowerCase()) {
            navigate(targetPath);
        }

        if (isMobile) {
            setIsMobilePageOpen(true);
        }
    };

    // Notify on initial load
    useEffect(() => {
        const isViewingPremiumMembers = activeItem === "Premium Members";
        window.dispatchEvent(new CustomEvent('premiumMembersView', {
            detail: { isViewing: isViewingPremiumMembers }
        }));
    }, []);

    // Add premium-page class
    useEffect(() => {
        document.body.classList.add('premium-page');

        return () => {
            document.body.classList.remove('premium-page');
        };
    }, []);

    const handleBackClick = () => {
        setIsMobilePageOpen(false);
        const normalizedPath = location.pathname.toLowerCase();
        if (normalizedPath !== "/premium-home" && normalizedPath !== "/premium-home/") {
            navigate("/premium-home");
        }
    };

    const renderContent = () => {
        if (!activeItem) return null;
        switch (activeItem) {
            case "Premium Members":
                return <PremiumMembers />;
            case "Consumer Apps Active":
                return <ConsumerAppActive />;
            case "Consumer App Settings":
                return <ConsumerAppSettings />;
            case "Info Requests":
                return <InfoRequests />;
            case "Listing Match":
                return <ListingMatch />;
            case "Custom App Store":
                return <CustomAppStore />;
            default:
                return <PremiumMembers />;
        }
    };

    function fetchDetailsAPI(userid) {
        console.log(userid)
        let formdata = new FormData();

        formdata.append("user_id", userid)
        formdata.append("key", "81dc9bdb52d04dc20036dbd8313ed055")

        fetch(baseURL.URL + '/consumers/users_count', {
            method: 'POST',
            body: formdata

        }).then((response) => response.json())
            .then((responseJson) => {
                const result = responseJson.response
                console.log(result)
                if (responseJson.server.result_code === 200) {
                    //navigate('InfoDetails')
                    //DATA = result
                    setPremiumMembersCount(result)
                }
                else {
                    //   Toast.showWithGravity(responseJson.server.message, Toast.SHORT, Toast.BOTTOM)
                    showNotification('Error', responseJson.server.message, 'danger');
                }
            })
            .catch((error) => {
                console.error(error);
            });
    }

    return (
        <section className="home">
            <div className="container">
                <div className="content-holder">
                    <PremiumSidebar
                        activeItem={activeItem}
                        setActiveItem={handleItemClick}
                    />
                    <div className={`content-right-wrapper ${isMobilePageOpen ? 'mobile-page-open' : ''}`}>
                        {isMobile && isMobilePageOpen && activeItem !== "Consumer Apps Active" && activeItem !== "Info Requests" && activeItem !== "Consumer App Settings" && (
                            <div className="mobile-page-header">
                                <button className="mobile-back-btn" onClick={handleBackClick}>
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                    >
                                        <path
                                            d="M15 18L9 12L15 6"
                                            stroke="white"
                                            strokeWidth="2"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </svg>
                                    Back
                                </button>
                                <h2 className="mobile-page-title">{activeItem}</h2>
                            </div>
                        )}
                        {renderContent()}
                    </div>
                </div>
            </div>
        </section>
    );
}

